<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- データ入力エリア -->
        <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name" >
                <td class="table-title pr-0">{{ item.name }}</td>
                <td v-if="item.requiredFlg" class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
                </td>
                <td v-else class="table-title">
                  <label class="tbl-lbl-blcok"></label>
                </td>
                <td class="table-td-1">
                  <template v-if="item.calendarFlg">
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                     
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          v-model="item.inputval"
                          label=""
                          persistent-hint
                          clearable
                          prepend-icon="mdi-calendar"
                          dense
                          solo
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.inputval"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <template v-if="item.textFlg">
                    <v-text-field label="" :placeholder='item.placeholderChrs' dense solo :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval" ></v-text-field>
                  </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- ボタンエリア -->
        <v-row style="margin-top: 0px !important;">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="info" dark min-width="200px"  @click="register()">登録</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="info" dark min-width="200px" @click="cancel()">キャンセル</v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-8" style="height: 10vh;"></v-row>
        
      </v-container>
    </v-main>
    <!-- フッター -->

    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";

export default {
  name: "ManagerModify",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: "管理ユーザ更新",
      screenId: "MTO210",
      messageArea: "",
      befUpdateDatetime: "",
      befUpdateUserId: "",
      desserts: [],
      pswdFlg: false,
      password: "Password",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        }
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "MTO220" }).href);
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'MTO220') {
      this.$store.commit("mainteAccountListSearch/resetState");
    }
    next();
  },
  methods: {
   /*
    * 初期表示
    */
    initialize: function () {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbc110.area');
      this.userId = this.$route.params.userNo;
      /* データ表示 */
      this.getManagerInfo(this.userId);
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },
    /*
    * 登録ボタン押下
    */
    register: async function () {
      // アカウント設定サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        let apiurl = Constants.getUrlApiMTO210P01(this.userId);
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.loading = false;
      }
      // 完了メッセージ表示
      this.showDialogMsg(apiErrorInfo, responseData);
    },

    /*
    * キャンセルボタン押下
    */
    cancel: function() {
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "MTO220" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },

   /*
    * ユーザ情報取得
    */
    getManagerInfo : async function(userId) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMTO210G01(userId);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        // ユーザ情報表示
        this.displyManagerInfo(response.data);

      } catch(error) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['ユーザ']);
          this.dlgMsg.isOpen = true;
          this.desserts.push({});
      } 
    },
    /*
    * 会員情報表示
    */
    displyManagerInfo : function(responseData) {
      this.desserts = new Array();
      if (responseData == null) {
        return;
      }
      let user = responseData.data; 
      
      this.desserts.push({ name: "ユーザID", inputval: user.userNo, placeholderChrs: "", pswdFlg: false, requiredFlg: true, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "氏名", inputval: user.name, placeholderChrs: "", pswdFlg: false, requiredFlg: true, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "氏名（フリガナ）", inputval: user.nameKana, placeholderChrs: "", pswdFlg: false, requiredFlg: true, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "現在のパスワード", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: false, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "新しいパスワード", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: false, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "新しいパスワード(確認)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: false, calendarFlg: false, textFlg: true})
      this.desserts.push({ name: "有効期間(開始)", inputval: user.validityperiodStartDate, placeholderChrs: "", pswdFlg: false, requiredFlg: true, calendarFlg: true, textFlg: false})
      this.desserts.push({ name: "有効期間(終了)", inputval: user.validityperiodEndDate, placeholderChrs: "", pswdFlg: false, requiredFlg: false, calendarFlg: true, textFlg: false})

      this.befUpdateDatetime = user.updateDatetime;
      this.befUpdateUserId = user.updateUserId;
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsg : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm112', ['ユーザ情報']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },
    /*
    * 登録用リクエストデータ生成
    */
    createRequestData : function() {
      let reqData = {};
      for (const value of this.desserts) {
        switch (value.name) {
          case 'ユーザID':
            reqData['userNo'] = value.inputval;
            break;
          case '氏名（フリガナ）':
            reqData['nameKana'] = value.inputval;
            break;
          case '氏名':
            reqData['name'] = value.inputval;
            break;
          case '現在のパスワード':
            reqData['pw'] = value.inputval;
            break;
          case '新しいパスワード':
            reqData['newPw'] = value.inputval;
            break;
          case '新しいパスワード(確認)':
            reqData['newPwConfirm'] = value.inputval;
            break;
          case '有効期間(開始)':
            reqData['validityperiodStartDate'] = value.inputval;
            break;
          case '有効期間(終了)':
            reqData['validityperiodEndDate'] = value.inputval;
            break;
        }      
      }
      reqData['updateDatetime'] = this.befUpdateDatetime;
      reqData['updateUserId'] = this.befUpdateUserId;

      return reqData;
    },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: center;
  padding: 6px 6px !important;
  font-size: 1.6em !important;
}
.table-td-btn {
  width: 140px;
  font-size: 0.6em !important;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 96%;
    margin: 5px 5px;
  }
  .table-title {
    white-space: nowrap;
    background-color: #f2f2f2;
    /* width: 34%; */
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    white-space: nowrap;
    background-color: #f2f2f2;
    width: 20%;
    text-align: right;
  }
  .table-td-1 {
    display: flex;
    text-align: center;
    padding: 6px 6px !important;
    font-size: 1.0em !important;
  }
  .table-td-btn {
    width: 20px;
    font-size: 0.4em !important;
  }
}
</style>
